import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "arrow", "button"]

  connect() {
    this.outsideClickHandler = this.outsideClick.bind(this)
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle("hidden")
    this.rotateArrow()
  }

  rotateArrow() {
    this.arrowTarget.classList.toggle('rotate-180')
  }

  outsideClick(event) {
    if (!this.buttonTarget.contains(event.target) && !this.menuTarget.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      this.arrowTarget.classList.remove('rotate-180')
    }
  }
}
